import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class SystemHealthService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	/**
	 * Get all health reports
	 * @param {function} callback
	 */
	getAllWithAuth(callback) {
		const url = "/health-app/api/health-reports-with-auth";
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get node status
	 * A list of nodes and up/down status - meant for use in HA deployment
	 * @param {function} callback
	 */
	getNodeStatus(timeout = 1000, callback) {
		const url = "/nodeStatus";
		this._restClient.exec_get({ url, timeout }, callback);
	}

	/**
	 * Stream health checks for the cluster
	 * @param {function} callback
	 */
	streamClusterHealth(callback) {
		this._rc.subscribe("health-app", "/clusterHealth", {}, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
